<template>
  <div class="h-9 md:h-10">
    <button @click="showDropdown = !showDropdown" ref="button">
      <div class="cursor-pointer h-9 md:h-10 w-9 md:w-10 bg-[#e3eafa] rounded-full p-2.5">
        <img class="w-5" src="/static/img/languages.svg" />
      </div>
    </button>
    <div
      v-closable="{ exclude: ['button', 'select'], handler: 'onClose', isOpen: showDropdown }"
      v-if="showDropdown"
      class="w-60  ltr:right-14 rtl:left-14 absolute  top-20 z-[51]"

    >
      <div class="maxMd:w-[90%] bg-white rounded-lg border-[0.74px] border-gray-300 shadow-ts1 grid gap-1 px-5 py-6 grid-cols-1 maxMd:m-auto z-[51] relative">
        <div class="grid gap-1 grid-cols-1 minMaxMobile:gap-x-8" ref="select">
          <div
            v-for="(locale, index) in languages"
            :key="locale"
            @click="changeLang(index)"
            :class="{ 'rounded-lg bg-white shadow-ts8': index === language }"
            class="flex items-center gap-16 cursor-pointer hover:rounded-lg hover:shadow-ts8 py-3 px-5 maxXs:px-3 maxMd:gap-6"
          >
            <img :src="getFlagSrc(locale)" :alt="locale" class="w-8 h-8 rounded-full maxMd:max-w-[30%]" />
            <span class="text-base text-gray-900">{{ locale }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '../config'

export default {
  data() {
    return {
      showDropdown: false,
      languages: config.languages,
      language: 'en',
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    this.language = this.Language
  },
  methods: {
    changeLang(index) {
      this.$bus.$emit('ChangeLang', index)
      this.language = index
      this.showDropdown = false
    },
    onClose() {
      this.showDropdown = false
    },
    getFlagSrc(locale) {
      const flagMap = {
        English: '/static/img/uk.svg',
        Spanish: '/static/img/spain.svg',
        Farsi: '/static/img/fa.svg',
      }
      return flagMap[locale]
    },
  },
}
</script>
